import request from '@/utils/request'

export function add(book) {
  return request({
    url: '/MedicineBook/add',
    method: 'post',
    data: book
  })
}

export function edit(book) {
  return request({
    url: '/MedicineBook/edit',
    method: 'post',
    data: book
  })
}
